"use client";

import { IconLayoutSidebar } from "@tabler/icons-react";
import { Button } from "../ui/button";
import { usePageSidebar } from "./page-with-sub-sidebar";
import { cn } from "@/lib/utils";

interface SubSidebarToggleProps {
  className?: string;
}

export function SubSidebarToggle({ className }: SubSidebarToggleProps) {
  const { menu } = usePageSidebar();

  return (
    <Button
      variant="ghost"
      size="md"
      onClick={menu.toggle}
      className={cn("md:hidden", className)}
      aria-label="Toggle sidebar"
      icon={<IconLayoutSidebar className="size-4" />}
    />
  );
}
